module.exports = "<!-- Wrapper-->\r\n<div id=\"wrapper\">\r\n  <!-- Top navigation -->\r\n  <topnavigationnavbar></topnavigationnavbar>\r\n  <!-- Main page wrapper -->\r\n  <div id=\"center-page\" class=\"gray-bg\">\r\n      <span defaultOverlayTarget></span>\r\n    <!-- Main view/routes wrapper-->\r\n    <router-outlet></router-outlet>\r\n\r\n    <!-- Footer -->\r\n    <footer></footer>\r\n\r\n  </div>\r\n</div>\r\n<!-- End wrapper-->\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/layouts/basicLayout.template.html
// module id = 1090
// module chunks = 0